import { useState } from 'react';
import { DEFAULT_HEADERS } from 'src/shared/constants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useDelete = () => {
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
	const { i18n } = useTranslation();

  const makeDeleteRequest = async (url: string) => {
    setLoading(true);
    const headers: any = {};
    const token = localStorage.getItem('token');
    if (!token) {
			if (i18n.language !== 'en') {
				navigate('/התחברות');
			} else {
				navigate('/en/login');
			}
    }
    headers.Authorization = `Bearer ${token}`;
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/${url}`, {
        method: 'DELETE',
        headers: {
          ...DEFAULT_HEADERS,
          ...headers,
        },
      });
      setLoading(false);
      return response;
    } catch (e) {
      setError(e);
    }
  };

  const invalidateError = () => {
    setError(null);
  };

  return {
    makeDeleteRequest,
    invalidateError,
    // data,
    error,
    loading,
  };
};

export default useDelete;
